import { render, staticRenderFns } from "./ProfileCardMini.vue?vue&type=template&id=3190f59b&scoped=true&"
import script from "./ProfileCardMini.vue?vue&type=script&lang=js&"
export * from "./ProfileCardMini.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCardMini.vue?vue&type=style&index=0&id=3190f59b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190f59b",
  null
  
)

export default component.exports